/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Coaches_DescriptionInputs */

const en_seo_coaches_description = /** @type {(inputs: Seo_Coaches_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a personal coach with open times this week and book your first session online, no account needed to look.`)
};

const pl_seo_coaches_description = /** @type {(inputs: Seo_Coaches_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera personalnego z wolnymi terminami w tym tygodniu i zarezerwuj pierwszy trening online. Do przeglądania nie potrzebujesz konta.`)
};

/**
* | output |
* | --- |
* | "Find a personal coach with open times this week and book your first session online, no account needed to look." |
*
* @param {Seo_Coaches_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_coaches_description = /** @type {((inputs?: Seo_Coaches_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Coaches_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_coaches_description(inputs)
	return en_seo_coaches_description(inputs)
});